import * as React from 'react';

import { TypographyProps } from '@mui/material/Typography';

import {
  AggregateBudgetStatus,
  BudgetStatus,
} from '@sbv-clients/data-access-api';
import {
  Badge,
  BadgeProps,
  CustomBadge,
  Typography,
} from '@sbv-clients/ui-shared';

export function minimalDecimal(value?: number, decimals = 2) {
  if (value === undefined) {
    return 0;
  }
  const coefficient = Math.pow(10, decimals);
  return Math.round(value * coefficient) / coefficient;
}

export function BudgetStatusBadge({
  budgetStatus,
  useBadge = true,
  decimals,
  simpleValue,
  fullWidth,
  textAlign = 'center',
}: {
  budgetStatus?: AggregateBudgetStatus;
  useBadge?: boolean;
  decimals?: number;
  simpleValue?: number;
  fullWidth?: boolean;
  textAlign?: TypographyProps['textAlign'];
}) {
  let type: BadgeProps['type'] = 'none';
  switch (budgetStatus?.budgetStatus) {
    case BudgetStatus.NUMBER_0:
      type = 'error';
      break;
    case BudgetStatus.NUMBER_1:
      type = 'error';
      break;
    case BudgetStatus.NUMBER_2:
      type = 'none';
      break;
    case BudgetStatus.NUMBER_3:
      type = 'info';
      break;
    case BudgetStatus.NUMBER_4:
      type = 'success';
      break;
  }

  if (budgetStatus?.assigned === 0 && budgetStatus.budget === 0) {
    type = 'none';
  }

  const underMin = budgetStatus?.budgetStatus === BudgetStatus.NUMBER_0;
  return (
    <Badge
      sx={{
        width: fullWidth ? '100%' : 'auto',
        textAlign,
      }}
      variant={useBadge && underMin ? 'dot' : undefined}
      color={'error'}
    >
      <CustomBadge sx={{ width: '100%' }} type={type}>
        {/*<Stack*/}
        {/*  spacing={1}*/}
        {/*  direction={'row'}*/}
        {/*  alignItems={'baseline'}*/}
        {/*  justifyContent={'center'}*/}
        {/*>*/}
        {/*  {underMin && <ErrorOutlineIcon sx={{ fontSize: 16 }} />}*/}
        <Typography fontSize={'small'}>
          {simpleValue !== undefined
            ? minimalDecimal(simpleValue, decimals)
            : budgetStatus
            ? `${minimalDecimal(
                budgetStatus.assigned,
                decimals
              )} / ${minimalDecimal(budgetStatus.budget, decimals)}`
            : 'N/A'}
        </Typography>
        {/*</Stack>*/}
      </CustomBadge>
    </Badge>
  );
}
